module.exports = __webpack_public_path__ + "f902e919de8e1a7b31742875a8972912.glb";